import { PaymentStatus } from '@/api/enumerations';
import { Constants } from '@/constants/finance';
import { IconCancelMS, IconCurrencyExchangeCopyMS } from '@/constants/icons';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';

export const Reason = memo(function Reason({
  reason,
  status,
}: {
  reason: string | null;
  status: PaymentStatus;
}) {
  const displayStatus = [PaymentStatus.CANCELLED, PaymentStatus.REFUNDED];
  const isRefund = status === PaymentStatus.REFUNDED;
  const mainColor = isRefund ? '#FB923C' : '#FF334B';
  const mainIcon = isRefund ? IconCurrencyExchangeCopyMS : IconCancelMS;
  const type = isRefund ? Constants.chargeback : Constants.cancellation;

  if (reason === null || !displayStatus.includes(status)) {
    return null;
  }

  return (
    <Box
      sx={{
        border: `1px solid ${mainColor}`,
        borderColor: mainColor,
        borderRadius: '12px',
        padding: '24px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          fontWeight: 600,
          fontSize: '21px',
          color: '#595959',
          textTransform: 'capitalize',
          span: {
            color: mainColor,
          },
        }}
      >
        {mainIcon}
        {type}
      </Box>
      <Box>
        {Constants.reason}
        <Typography pt="8px">{reason}</Typography>
      </Box>
    </Box>
  );
});
